module.exports = __webpack_public_path__ + "static/media/icon-back.770f1880.svg";